<div class="content">
  <div class="form-container chat-form">
    {{ 'Discussion' | translate }}
    <div class="chat-list mt-2">
      <div class="mb-1" [ngClass]="currentUser.user_id === chat.sender.id ? 'me bg-primary' : 'other'" *ngFor="let chat of chats; trackById">
        <p>{{ chat.content }}</p>
        <p [ngClass]="currentUser.user_id === chat.sender.id ? 'text-right' : ''"><small>- {{chat.sender.username}}</small></p>
      </div>
    </div>
    <form [formGroup]="chatForm">
      <div>
        <div class="form-group">
          <textarea formControlName="message" type="text" class="form-control" (keyup.enter)="sendChat()"
            placeholder="{{ 'Message' | translate }}"></textarea>
        </div>
      </div>
    </form>
  </div>
</div>